import type { IconData } from '@stacksjs/iconify-core'

export const ly1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGc8sMwd7h\"><path d=\"M250 12h500v500H250z\"/></clipPath></defs><g clip-path=\"url(#SVGc8sMwd7h)\" transform=\"translate(-256 -12.3)scale(1.024)\"><path fill=\"#239e46\" d=\"M0 12h1000v500H0z\"/><path fill=\"#000001\" d=\"M0 12h1000v375H0z\"/><path fill=\"#e70013\" d=\"M0 12h1000v125H0z\"/><path fill=\"#fff\" d=\"M544.2 217.8a54.3 54.3 0 1 0 0 88.4a62.5 62.5 0 1 1 0-88.4M530.4 262l84.1-27.3l-52 71.5v-88.4l52 71.5z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ly1x1
